const Loader = () => {
    const circleStyle = {
      width: '1rem',
      height: '1rem',
      backgroundColor: '#FF9A66',
      borderRadius: '9999px', // Tailwind utility for fully rounded corners
      position: 'absolute',
    };
  
    return (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[80] flex justify-center items-center">
        <div
            className="relative w-10 h-10 animate-spin988"
            style={{ animation: 'spin988 2s linear infinite' }}
        >
            <div style={{ ...circleStyle, top: '0', left: '0' }}></div>
            <div style={{ ...circleStyle, top: '0', right: '0' }}></div>
            <div style={{ ...circleStyle, bottom: '0', left: '0' }}></div>
            <div style={{ ...circleStyle, bottom: '0', right: '0' }}></div>
        </div>
      </div>
    );
  };

export default Loader;